import React from "react";
import { hasPermission } from "../utils/permissions";

const AccessControl = ({ role, permission, children }) => {
  if (!hasPermission(role, permission)) {
    return null;
  }

  return children;
};

export default AccessControl;
